module.exports = __webpack_public_path__ + "static/a2-4c27067a4eae96961afc68f86fa5466a.jpg";